<template>
  <div>
    <common-table :url="url"
                  :table-columns="tableColumns"
                  :form-fields="formFields"
                  :operate="[]"
                  :permission="permission"
                  :searchs="searchs"
                  ref="table"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
export default {
  name: "MiningMachine",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }],
      permission:{
        add: 'miningMachine:add',
        update: 'miningMachine:update',
        delete: 'miningMachine:delete',
        deleteBatch: 'miningMachine:deleteBatch'
      },
      url: {
        get: '/miningMachine/listByCondition',
        add: '/miningMachine/add',
        update: '/miningMachine/update',
        delete: '/miningMachine/delete/',
        delete_batch: '/miningMachine/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'mining',
        label: '矿机等级',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'name',
        label: '矿机名称',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'ratio',
        label: '矿比例',
        show: {
          type: 'thousandthsRatio'
        },
        width: ''
      }, {
        field: 'quantify',
        label: '量化次数',
        show: true,
        detail: true,
        width: '',
      },  {
        field: 'effectiveInvite',
        label: '邀请人数',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'rechargeAmount',
        label: '下级会员首次充值金额',
        show: true,
        detail: true,
        width: '',
      },{
        field: 'rechargeStart',
        label: '累计充值数量',
        show: true,
        detail: true,
        width: '',
      }/*,{
        field: 'everyRatio',
        label: '每次量化比例',
        show: true,
        detail: true,
        width: '',
      }*/,{
        field: 'remark',
        label: '矿机描述',
        show: true,
        detail: true,
        width: '',
      },{
        field: 'createTime',
        label: '时间',
        show: true,
        width: '180px',
      }],
      formFields: {
        addTitle: '添加用户',
        updateTitle: '修改用户',
        labelWidth: '80px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'mining',
          label: '矿机等级',
          type: 'input',
          placeholder: '矿机等级',
          rules: [{
            message: '请输入矿机等级', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'name',
          label: '矿机名称',
          type: 'input',
          placeholder: '矿机名称',
          rules: [{
            message: '请输入矿机名称', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'ratio',
          label: '矿比例',
          type: 'money',
          placeholder: '比例(%)',
          rules: [{
            message: '请输入比例(%)', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'quantify',
          label: '量化次数',
          type: 'input',
          placeholder: '量化次数',
          rules: [{
            message: '请输入量化次数', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'effectiveInvite',
          label: '邀请人数',
          type: 'input',
          placeholder: '邀请人数',
          rules: [{
            message: '请输入邀请人数', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'rechargeAmount',
          label: '下级会员首次充值金额',
          type: 'input',
          placeholder: '下级会员首次充值金额',
          rules: [{
            message: '请输入下级会员首次充值金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'rechargeStart',
          label: '累计充值数量',
          type: 'input',
          placeholder: '累计充值数量',
          rules: [{
            message: '请输入累计充值数量', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }/*,{
          field: 'everyRatio',
          label: '每次量化比例',
          type: 'input',
          placeholder: '每次量化比例',
          rules: [{
            message: '请输入每次量化比例,格式为：100,200,300，量化几次写几组', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }*/,{
          field: 'remark',
          label: '矿机描述',
          type: 'input',
          placeholder: '矿机描述',
          rules: [{
            message: '请输入矿机描述', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }]
      }
    }
  }
}
</script>

<style scoped>

</style>
